<template>
  <el-dialog title=" Quick Edit" :close-on-click-modal="false" :visible.sync="visible" width="1400px" top="1vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="14">
          <el-card class="box-card">
            <div slot="header">Basic Information</div>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item label="Client code" prop="clientCode">
                  <el-input v-model="dataForm.clientCode" disabled placeholder="Enter number" maxlength="30" show-word-limit>
                    <template slot="prepend">c</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="UEN" prop="uen">
                  <uen-input-remote-search v-model="dataForm.uen" disabled class="wdb100"></uen-input-remote-search>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Country" prop="country">
                  <el-select v-model="dataForm.country" disabled filterable clearable placeholder="Select Country" class="wdb100">
                    <el-option v-for="item in countryList" :key="`basic-${item.value}`" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Company Name" prop="companyName">
                  <el-input v-model="dataForm.companyName" disabled placeholder="Full legal name" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Attention" prop="attention">
                  <el-input v-model="dataForm.attention" placeholder="Attn: Person / Dept" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Coordinator" prop="coordinatorIds">
                  <el-select v-model="dataForm.coordinatorIds" filterable multiple clearable placeholder="Select Coordinator" class="wdb100">
                    <el-option
                      v-for="item in userList"
                      :key="`client-alert-${item.id}`"
                      :label="item.nickname || item.username"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Description" prop="remark">
                  <el-input
                    v-model="dataForm.remark"
                    type="textarea"
                    :rows="4"
                    :autosize="{ minRows: 3 }"
                    resize="none"
                    placeholder="Description"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="mt10 box-card">
            <div slot="header">Commission</div>
            <el-row :gutter="10">
              <el-col :span="7">
                <el-form-item label="Introduced By" prop="introducedBy">
                  <el-select v-model="dataForm.introducedBy" disabled class="wdb100">
                    <el-option v-for="item in introducedByList" :key="`introducedBy${item.title}`" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item label="Commission" prop="commissionList" class="selectDisabled" v-if="dataForm.introducedBy == 1">
                  <el-select
                    v-model="dataForm.commissionList"
                    disabled
                    value-key="id"
                    filterable
                    clearable
                    multiple
                    placeholder="Please Select"
                    class="wdb100"
                  >
                    <el-option
                      v-for="item in commissionRequiredList"
                      :key="item.id"
                      :label="`${item.name} - ${percentageFormat(item.commissionRate)}`"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="10">
          <el-card class="box-card">
            <div slot="header">Relationship</div>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="Introducer" prop="introducer">
                  <el-input v-model="dataForm.introducer" placeholder="Who introduced this client?" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Marketing Tags" prop="tagIds">
                  <el-select v-model="dataForm.tagIds" filterable multiple clearable class="wdb100">
                    <el-option v-for="item in tagInfoList" :key="`tag-${item.id}`" :label="item.tagName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Relationship" prop="relationshipRemark">
                  <el-input
                    v-model="dataForm.relationshipRemark"
                    type="textarea"
                    :rows="15"
                    :autosize="{ minRows: 14 }"
                    resize="none"
                    placeholder="Internal notes…"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <el-card class="mt10 box-card">
        <div slot="header" class="clearfix">
          <div class="headerWrap">
            <span>Billing Addresses</span>
            <el-button icon="el-icon-plus" size="mini" @click="addBillingHandle">Add</el-button>
          </div>
        </div>
        <div>
          <el-form-item prop="billingInfoList">
            <div class="itemListWrap">
              <el-row :gutter="10">
                <el-col :span="6" class="itemTitle">Street Address</el-col>
                <el-col :span="6" class="itemTitle">Country</el-col>
                <el-col :span="6" class="itemTitle">Zone (manual)</el-col>
                <el-col :span="5" class="itemTitle">Postal / ZIP Code</el-col>
              </el-row>
              <div class="wdb100" v-for="(ele, index) in dataForm.billingInfoList" :key="`billing-${index}`">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item
                      :prop="`billingInfoList.${index}.billingAddress`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.billingAddress" placeholder="Street, building, unit…" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :prop="`billingInfoList.${index}.billingCountry`">
                      <el-select v-model="ele.billingCountry" filterable clearable placeholder="Select Country" class="wdb100">
                        <el-option v-for="item in countryList" :key="`billing-${index}-${item.value}`" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :prop="`billingInfoList.${index}.billingZone`">
                      <el-input v-model="ele.billingZone" placeholder="e.g. Central, Admiralty…" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :prop="`billingInfoList.${index}.billingPostalCode`">
                      <el-input v-model="ele.billingPostalCode" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" class="tac">
                    <el-button type="danger" size="small" icon="el-icon-delete" plain @click="deleteBillingHandle(index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-card>
      <el-card class="mt10 box-card">
        <div slot="header">
          <div class="headerWrap">
            <span>Contact Persons</span>
            <el-button icon="el-icon-plus" size="mini" @click="addContactHandle">Add</el-button>
          </div>
        </div>
        <div>
          <el-form-item prop="contactInfoList">
            <div class="itemListWrap">
              <el-row :gutter="14">
                <el-col :span="8" class="itemTitle">Contact Name</el-col>
                <el-col :span="8" class="itemTitle">Email (Receive Marketing Emails)</el-col>
                <el-col :span="7" class="itemTitle">Position</el-col>
              </el-row>
              <div class="wdb100" v-for="(ele, index) in dataForm.contactInfoList" :key="`billing-${index}`">
                <el-row :gutter="14">
                  <el-col :span="8">
                    <el-form-item
                      :prop="`contactInfoList.${index}.contactName`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.contactName" placeholder="Mr./Ms. Full Name" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" class="flex">
                    <el-form-item
                      :prop="`contactInfoList.${index}.contactEmail`"
                      :rules="{
                        type: 'email',
                        message: 'please provide a valid email address',
                        trigger: 'submit',
                      }"
                      class="wdb100 mr8"
                    >
                      <el-input v-model="ele.contactEmail" placeholder="email@company.com" clearable></el-input>
                    </el-form-item>
                    <el-form-item :prop="`contactInfoList.${index}.isReceiveEmail`">
                      <el-checkbox v-model="ele.isReceiveEmail" class="customLabel">Receive</el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item :prop="`contactInfoList.${index}.contactPosition`">
                      <el-input v-model="ele.contactPosition" placeholder="CEO, Manager…" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" class="tac">
                    <el-button type="danger" size="small" icon="el-icon-delete" plain @click="deleteContactHandle(index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UenInputRemoteSearch from "@/components/InputRemoteSearch/uen";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    userList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tagInfoList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    commissionRequiredList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    UenInputRemoteSearch,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        clientCode: "",
        uen: "",
        companyName: "",
        country: "",
        attention: "",
        coordinatorIds: [],
        remark: "",
        introducer: "",
        tagIds: [],
        relationshipRemark: "",
        billingInfoList: [],
        contactInfoList: [],
        introducedBy: null,
        commissionList: [],
      },
      dataRule: {},
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "introducedByList"]),
  },
  methods: {
    // 初始化
    async init(data) {
      this.visible = true;
      this.submitLoading = false;
      // 需要手动设置为[],不然会报错
      this.$set(this.dataForm, "billingInfoList", []);
      this.$set(this.dataForm, "contactInfoList", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        const coordinatorIds = dataCopy.coordinatorList?.map(item => item.id) || [];
        const tagIds = dataCopy.tagList?.map(item => item.id) || [];
        this.dataForm = {
          id: dataCopy.id,
          clientCode: dataCopy.clientCode?.slice(1) || "",
          uen: dataCopy.uen,
          companyName: dataCopy.companyName,
          country: dataCopy.country,
          attention: dataCopy.attention,
          coordinatorIds,
          remark: dataCopy.remark,
          introducer: dataCopy.introducer,
          tagIds,
          relationshipRemark: dataCopy.relationshipRemark,
          billingInfoList: dataCopy.billingInfoList || [],
          contactInfoList: (dataCopy.contactInfoList || []).map(item => ({
            ...item,
            isReceiveEmail: item.isReceiveEmail === true || item.isReceiveEmail === "true",
          })),
          introducedBy: dataCopy.introducedBy,
          commissionList: dataCopy.introducedBy == 1 ? dataCopy.commissionList || [] : [],
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // Billing Addresses - 添加
    addBillingHandle() {
      this.dataForm.billingInfoList.push({
        billingAddress: "",
        billingCountry: "",
        billingPostalCode: "",
        billingZone: "",
      });
    },
    // Billing Addresses - 删除
    deleteBillingHandle(index) {
      this.dataForm.billingInfoList.splice(index, 1);
    },
    // Contact Persons - 添加
    addContactHandle() {
      this.dataForm.contactInfoList.push({
        contactName: "",
        contactEmail: "",
        isReceiveEmail: false,
        contactPosition: "",
      });
    },
    // Contact Persons - 删除
    deleteContactHandle(index) {
      this.dataForm.contactInfoList.splice(index, 1);
    },
    // 表单提交（后端仅接收可编辑字段）
    formSubmitRequest() {
      const { id, attention, remark, introducer, coordinatorIds, tagIds, relationshipRemark, contactInfoList, billingInfoList } = this.dataForm;
      const params = {
        attention,
        remark,
        introducer,
        coordinatorIds,
        tagIds,
        relationshipRemark,
        contactInfoList,
        billingInfoList,
      };
      return this.$http.post(`/admin/clientCodeInfoManage/${id}/updateBaseInfo`, params);
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.$emit("refreshDataList");
                  this.visible = false;
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  ::v-deep {
    .el-card__header {
      padding: 14px 16px;
      font-size: 15px;

      .headerWrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .el-card__body {
      padding: 6px 16px 0;
    }

    .selectDisabled {
      .el-select__input {
        cursor: not-allowed !important;
      }
      .el-tag {
        cursor: not-allowed !important;
      }
    }
  }
}

.itemListWrap {
  .itemTitle {
    font-size: 13px;
    text-align: center;
  }

  .notSelectTipBg {
    padding: 6px 10px;
  }

  ::v-deep {
    .customLabel {
      .el-checkbox__label {
        padding-left: 6px;
      }
    }
  }
}
</style>
